module.exports = __webpack_public_path__ + "static/media/02.b8525ad7.jpg";